// IMPORT PACKAGE REFERENCES
import React from 'react';
import { SignupConfirmComponent } from '../SignUp';

// IMPORT PROJECT REFERENCES

// COMPONENT

export const SignupConfirmPage = () => <SignupConfirmComponent />;
